import { useEffect, useState } from 'react';
import Allocations from './Allocations';
import './Allocations.scss';
import LayoutContainer from 'modules/shared/components/_layout/layout-container/LayoutContainer';
import TitleBarContainer from 'modules/shared/components/top-bars/title-bar/TitleBarContainer';
import { clientsService } from 'modules/Administration/clients-manage/services/clients';
import { projectsService } from '../services/projects';
import { allocationsService } from '../services/allocations';

const AllocationsContainer = props => {
  const savedSortModel = localStorage.getItem('dataGridSort');
  const savedPathname = localStorage.getItem('pathname');
  const [sortModel, setSortModel] = useState(
    savedSortModel && savedPathname === props?.location.pathname ? JSON.parse(savedSortModel) : []
  );
  const handleSortChange = newSortModel => {
    setSortModel(newSortModel);
    localStorage.setItem('dataGridSort', JSON.stringify(newSortModel));
  };
  const savedPage = sessionStorage.getItem('allocationEmployee.currentPage');
  const [page, setPage] = useState(savedPage ? parseInt(savedPage) : 1);

  const [clients, setClients] = useState([]);
  const [clientProjects, setClientProjects] = useState([]);

  const [isFiltered, setIsFiltered] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [allocations, setAllocations] = useState([]);
  const [filteredAllocations, setFilteredAllocations] = useState([]);
  const [filterForm, setFilterForm] = useState({
    clientId: '',
    projectId: '',
    startDate: null,
    endDate: null
  });
  const navigate = route => {
    props.history.push(route, { prevPathname: props?.location?.pathname });
  };

  const getProjects = async clientId => {
    const projectsData = await projectsService.getClientProjects(clientId);
    setClientProjects(projectsData?.data);
  };
  const getAllocations = async () => {
    const allocationsData = await allocationsService.getAllocations();
    setAllocations(allocationsData?.data);
    setFilteredAllocations(allocationsData?.data);
  };

  const handleChange = event => {
    if (event?.target.name === 'clientId') {
      getProjects(event.target.value);
    }
    setFilterForm({ ...filterForm, [event.target.name]: event.target.value });
  };

  const dateHandleChange = (name, value) => {
    setFilterForm({ ...filterForm, [name]: value });
  };
  const fetchData = async () => {
    setIsLoading(true);
    const clientsData = await clientsService.filter();
    setClients(clientsData);
    getAllocations();
    setIsLoading(false);
  };
  useEffect(() => {
    sessionStorage.setItem('empSkills.currentPage', '1');
    setPage(1);
    localStorage.setItem('pathname', props?.location?.pathname);
    fetchData();
  }, [props?.location?.pathname]);

  const applyFilter = async () => {
    setIsLoading(true);
    const filterAllocations = allocations?.filter(item => {
      const matchesClientId = filterForm.clientId
        ? item.clientId === Number(filterForm.clientId)
        : true;
      const matchesProjectId = filterForm.projectId
        ? item.projectId === Number(filterForm.projectId)
        : true;
      const matchesStartDate = filterForm.startDate
        ? new Date(item.startDate) >= new Date(filterForm.startDate)
        : true;
      const matchesEndDate = filterForm.endDate
        ? new Date(item.endDate) <= new Date(filterForm.endDate)
        : true;
      return matchesClientId && matchesProjectId && matchesStartDate && matchesEndDate;
    });
    setFilteredAllocations(filterAllocations);
    setIsLoading(false);
  };

  const clearFilter = () => {
    setFilterForm({
      clientName: '',
      projectName: '',
      startDate: null,
      endDate: null
    });
    setFilteredAllocations(allocations);
    setIsFiltered(false);
  };

  const titleBar = (
    <TitleBarContainer
      style={{ height: '64px', paddingTop: 0 }}
      title="Allocations"
      backRoute="/"
    />
  );
  return (
    <LayoutContainer titleBar={titleBar}>
      <Allocations
        clients={clients}
        clientProjects={clientProjects}
        handleChange={handleChange}
        filterForm={filterForm}
        dateHandleChange={dateHandleChange}
        allocations={filteredAllocations}
        navigate={navigate}
        isLoading={isLoading}
        isFiltered={isFiltered}
        handleSortChange={handleSortChange}
        sortModel={sortModel}
        page={page}
        setPage={setPage}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
      />
    </LayoutContainer>
  );
};

export default AllocationsContainer;
